import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useDeleteProject } from "@/hooks/queries";

export function DeleteProjectDialog({ project, open, onOpenChange }) {
  const del = useDeleteProject();
  const navigate = useNavigate();
  const confirm = async (e) => {
    e.preventDefault();
    try {
      await del.mutateAsync(project.id);
      toast.success("Project deleted");
      onOpenChange(false);
      navigate("/projects", { replace: true });
    } catch (err) {
      toast.error(err.message);
    }
  };
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="border-white/10 bg-ink-850" data-testid="delete-project-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">Delete “{project?.name}”?</AlertDialogTitle>
          <AlertDialogDescription className="text-zinc-400">
            The project and its instructions will be deleted. Its chats move to your chat history and its files stay in Files. Prefer to keep it? Archive it instead.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="border-white/10 bg-transparent text-zinc-300 hover:bg-white/[0.06] hover:text-white" data-testid="delete-project-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={confirm} disabled={del.isPending} className="bg-rose-500 text-white hover:bg-rose-500/90" data-testid="delete-project-confirm">
            {del.isPending ? "Deleting…" : "Delete project"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
